import * as React from 'react';
import { Field } from 'redux-form';

import Input from 'af-fields/Input';

import JobUpsertFM from '../../../formModel';
import { formSectionClassColumn2, formSectionClassRow } from '../../../helpers';
import styles from '../../../styles.module.scss';

interface OwnProps {
	disabled: boolean;
}

type Props = OwnProps;

const AdditionalBillingInformation: React.FC<Props> = (props) => {
	const { disabled } = props;

	return (
		<>
			<div className={styles['job-form__billing-information-title']}>
				Billing Information
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billTo"
						label="Bill To"
						name={JobUpsertFM.getAttributeName('billTo')}
						placeholder="Enter Bill To"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billToAddress"
						label="Address"
						name={JobUpsertFM.getAttributeName('billToAddress')}
						placeholder="Enter Address"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billToCityStateZip"
						label="City, State, Zip"
						name={JobUpsertFM.getAttributeName('billToCityStateZip')}
						placeholder="Enter City, State, Zip"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billToContactName"
						label="Contact Name"
						name={JobUpsertFM.getAttributeName('billToContactName')}
						placeholder="Enter Contact Name"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billToPhoneNumber"
						label="Phone Number"
						name={JobUpsertFM.getAttributeName('billToPhoneNumber')}
						placeholder="Enter Phone Number"
						type="tel"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billToFaxNumber"
						label="Fax Number"
						name={JobUpsertFM.getAttributeName('billToFaxNumber')}
						placeholder="Enter Fax Number"
					/>
				</div>
				<div className={formSectionClassColumn2}>
					<Field
						component={Input}
						disabled={disabled}
						id="billToEmail"
						label="Email Address"
						name={JobUpsertFM.getAttributeName('billToEmail')}
						placeholder="Enter Email Address"
					/>
				</div>
			</div>
		</>
	);
};

export default React.memo(AdditionalBillingInformation);
